import { render, staticRenderFns } from "./qrcode.vue?vue&type=template&id=6b96953d&scoped=true"
import script from "./qrcode.vue?vue&type=script&lang=ts"
export * from "./qrcode.vue?vue&type=script&lang=ts"
import style0 from "./qrcode.vue?vue&type=style&index=0&id=6b96953d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b96953d",
  null
  
)

export default component.exports